module.exports = __webpack_public_path__ + "img/profile-title-bm.38b0f8a2.png";